export default __webpack_public_path__ + "static/media/mainImg.7e1d4ab6.jpg";